// extracted by mini-css-extract-plugin
export default {"centerIconCell":"BillingPage_centerIconCell__gzPi9"};